import beforeEnter from '../utils'

export default {
  path: '/painel/:id',
  component: () => import('@/App.vue'),
  beforeEnter: (to, from, next) => beforeEnter(to, from, next),
  children: [
    {
      path: '',
      component: () => import('@/pages/Layout.vue'),
      children: [
        {
          path: 'login',
          name: 'login-painel',
          component: () => import('@/pages/Paineis/Login.vue')
        },
        {
          path: '',
          name: 'painel',
          component: () => import('@/pages/Paineis/Home.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'mega01',
          name: 'mega01',
          component: () => import('@/pages/Paineis/MegaImagem/Informativo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'mega02',
          name: 'mega02',
          component: () => import('@/pages/Paineis/MegaImagem/Tma.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
}
